import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/BlogHero/BlogHero.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/blog/RelatedPosts/RelatedPosts.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/[locale]/blog/[slug]/blogPost.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/blogui/RichTextRenderer.tsx");
